import React, { useContext } from 'react';
import './AlarmHistory.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardAlarmHistoryContext } from '../../contexts/CardAlarmHistoryContext';
import logComponent from '../../common/logComponent';

export default function AlarmHistoryLoadingStatus({ reloadAction }) {
  const cardAlarmHistoryContext = useContext(CardAlarmHistoryContext);
  const { alarmHistoryLoading, alarmHistoryError } = cardAlarmHistoryContext;

  if (logComponent('AlarmHistoryLoadingStatus')) { console.debug('AlarmHistoryLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={alarmHistoryLoading} isError={alarmHistoryError} reloadAction={reloadAction} />
  );
}